var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router';
import { useProfileContext } from '../ProfileContext';
import { determineNextStepLink } from '../utils';
var NextStepCTA = function () {
    var profileData = useProfileContext().profileData;
    var _a = determineNextStepLink(profileData), to = _a.to, text = _a.text;
    return (_jsx(Link, __assign({ viewTransition: true, className: "\n        w-full block px-8 py-4 text-sm-reg-m md:text-sm-reg-d bg-shoe rounded-full no-underline\n        hover:no-underline hover:bg-shoe-950 !font-medium !text-bone", to: to }, { children: text })));
};
export default NextStepCTA;
